import { VehicleDetailImagesType } from "models/inventory/enums/vehicle-images.enums";

export const translateEngineType = (engineType: string): string => {
  const translations: { [key: string]: string } = {
    "4-stroke": "4 tiempos",
    "2-stroke": "2 tiempos",
    "electric": "eléctrico",
    "hybrid": "híbrido",
    "diesel": "diésel",
    "gasoline": "gasolina",
    "petrol": "gasolina",
    "natural gas": "gas natural",
    "lpg": "GLP",
    "cng": "GNC"
  };

  return translations[engineType.toLowerCase()] || engineType;
};

export const translateFuelSystem = (fuelSystem: string): string => {
  const translations: { [key: string]: string } = {
    "fuel injection": "inyección de combustible",
    "carburetor": "carburador",
    "direct injection": "inyección directa",
    "indirect injection": "inyección indirecta",
    "electronic fuel injection": "inyección electrónica de combustible",
    "mechanical fuel injection": "inyección mecánica de combustible",
    "common rail": "common rail",
    "unit injector": "inyector unitario",
    "pump injector": "inyector bomba",
    "port fuel injection": "inyección multipunto",
    "throttle body injection": "inyección monopunto",
    "sequential fuel injection": "inyección secuencial",
    "simultaneous fuel injection": "inyección simultánea"
  };

  return translations[fuelSystem.toLowerCase()] || fuelSystem;
};

export const translateTransmission = (transmission: string): string => {
  const translations: { [key: string]: string } = {
    "manual": "manual",
    "automatic": "automática",
    "semi-automatic": "semiautomática",
    "cvt": "transmisión variable continua",
    "dual-clutch": "doble embrague",
    "sequential": "secuencial",
    "automated manual": "manual automatizada",
    "torque converter": "convertidor de par",
    "direct drive": "transmisión directa",
    "chain drive": "transmisión por cadena",
    "belt drive": "transmisión por correa",
    "shaft drive": "transmisión por cardán"
  };

  return translations[transmission.toLowerCase()] || transmission;
};

export const translateCoolingSystem = (coolingSystem: string): string => {
  const translations: { [key: string]: string } = {
    "liquid cooled": "refrigerado por líquido",
    "air cooled": "refrigerado por aire",
    "oil cooled": "refrigerado por aceite",
    "water cooled": "refrigerado por agua",
    "forced air": "aire forzado",
    "natural air": "aire natural",
    "thermosiphon": "termosifón",
    "forced circulation": "circulación forzada",
    "evaporative": "evaporativo",
    "radiator": "radiador",
    "heat exchanger": "intercambiador de calor"
  };

  return translations[coolingSystem.toLowerCase()] || coolingSystem;
};

export const translateFrontSuspension = (suspension: string): string => {
  const translations: { [key: string]: string } = {
    "telescopic fork": "horquilla telescópica",
    "upside-down fork": "horquilla invertida",
    "twin shock": "doble amortiguador",
    "single shock": "amortiguador único",
    "leading link": "brazo guía",
    "trailing link": "brazo arrastrado",
    "swingarm": "brazo oscilante",
    "telescopic": "telescópica",
    "inverted": "invertida",
    "conventional": "convencional",
    "cartridge": "cartucho",
    "air suspension": "suspensión de aire",
    "spring preload": "precarga de resorte"
  };

  return translations[suspension.toLowerCase()] || suspension;
};

export const translateRearSuspension = (suspension: string): string => {
  const translations: { [key: string]: string } = {
    "mono shock": "monoamortiguador",
    "twin shock": "doble amortiguador",
    "swingarm": "brazo oscilante",
    "cantilever": "cantilever",
    "linkage": "sistema de enlaces",
    "progressive": "progresiva",
    "adjustable": "ajustable",
    "air suspension": "suspensión de aire",
    "spring preload": "precarga de resorte",
    "rebound damping": "amortiguación de rebote",
    "compression damping": "amortiguación de compresión",
    "hydraulic": "hidráulica",
    "pneumatic": "neumática"
  };

  return translations[suspension.toLowerCase()] || suspension;
};

export const translateBrakeSystem = (brakeSystem: string): string => {
  const translations: { [key: string]: string } = {
    "disc brake": "freno de disco",
    "drum brake": "freno de tambor",
    "hydraulic": "hidráulico",
    "mechanical": "mecánico",
    "abs": "sistema antibloqueo de frenos",
    "cbs": "sistema combinado de frenos",
    "dual disc": "doble disco",
    "single disc": "disco único",
    "ventilated": "ventilado",
    "floating": "flotante",
    "fixed": "fijo",
    "radial": "radial",
    "axial": "axial",
    "linked": "vinculado",
    "regenerative": "regenerativo"
  };

  return translations[brakeSystem.toLowerCase()] || brakeSystem;
};

export const translateImageType = (imageType: VehicleDetailImagesType): string => {
  const translations: Record<VehicleDetailImagesType, string> = {
    [VehicleDetailImagesType.frontLightsPhoto]: "Luces delanteras",
    [VehicleDetailImagesType.exhaustPhoto]: "Escape",
    [VehicleDetailImagesType.frontWheelPhoto]: "Llanta delantera",
    [VehicleDetailImagesType.dashboardPhoto]: "Tablero",
    [VehicleDetailImagesType.trunkOrSeatOpenPhoto]: "Baúl o asiento abierto",
    [VehicleDetailImagesType.rearSuspensionPhoto]: "Suspensión trasera",
    [VehicleDetailImagesType.rearLightPhoto]: "Luz trasera",
    [VehicleDetailImagesType.rearWheelPhoto]: "Rueda trasera",
    [VehicleDetailImagesType.offRoadPhoto]: "Terreno destapado",
    [VehicleDetailImagesType.urbanEnvironmentPhoto]: "Entorno urbano",
    [VehicleDetailImagesType.withDriverPhoto]: "Conductor",
    [VehicleDetailImagesType.realEnvironmentParkedPhoto]: "Estacionado en entorno real",
    [VehicleDetailImagesType.motionDetailPhoto]: "Detalle en movimiento",
  };

  return translations[imageType] || imageType;
};
